import { ShopItemType } from '../../types/shop';

export const SHOP_ITEMS_STREAM_GROUP_ID = 'shop';

export const getShopItemsStreamId = (type: ShopItemType): string =>
  `${SHOP_ITEMS_STREAM_GROUP_ID}_${type}_ids_stream`.toUpperCase();
